module.exports = __webpack_public_path__ + "img/mono_1.fc6f94b9.png";